import "../DrugOrderConfirmLotTable/DrugOrderConfirmLotTable.css";

const StudyTableComp = ({ data }) => {
  return (
    <div className="drug-order-confirm-lot-table-container">
      <table className="drug-order-confirm-lot-table">
        <thead className="drug-order-confirm-lot-table-header">
          <tr>
            <th className="drug-order-confirm-table-header-name">Kit Number</th>
            <th className="drug-order-confirm-table-header-name">Status</th>
          </tr>
        </thead>
        <tbody style={{ textAlign: "center" }}>
          {data &&
            Object.entries(data).map(([drugId, status], index) => (
              <tr key={index}>
                <td className="drug-order-confirm-table-data">{drugId}</td>
                <td className="drug-order-confirm-table-data">{status}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default StudyTableComp;
